import { utils } from '@pixi/core';
function fixOrientation(points) {
  var hole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var m = points.length;
  if (m < 6) {
    return;
  }
  var area = 0;
  for (var i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2) {
    var x2 = points[i];
    var y2 = points[i + 1];
    area += (x2 - x1) * (y2 + y1);
    x1 = x2;
    y1 = y2;
  }
  if (!hole && area > 0 || hole && area <= 0) {
    var n = m / 2;
    for (var _i = n + n % 2; _i < m; _i += 2) {
      var i1 = m - _i - 2;
      var i2 = m - _i - 1;
      var i3 = _i;
      var i4 = _i + 1;
      var _ref = [points[i3], points[i1]];
      points[i1] = _ref[0];
      points[i3] = _ref[1];
      var _ref2 = [points[i4], points[i2]];
      points[i2] = _ref2[0];
      points[i4] = _ref2[1];
    }
  }
}
var buildPoly = {
  build: function build(graphicsData) {
    graphicsData.points = graphicsData.shape.points.slice();
  },
  triangulate: function triangulate(graphicsData, graphicsGeometry) {
    var points = graphicsData.points;
    var holes = graphicsData.holes;
    var verts = graphicsGeometry.points;
    var indices = graphicsGeometry.indices;
    if (points.length >= 6) {
      fixOrientation(points, false);
      var holeArray = [];
      for (var i = 0; i < holes.length; i++) {
        var hole = holes[i];
        fixOrientation(hole.points, true);
        holeArray.push(points.length / 2);
        points = points.concat(hole.points);
      }
      var triangles = utils.earcut(points, holeArray, 2);
      if (!triangles) {
        return;
      }
      var vertPos = verts.length / 2;
      for (var _i2 = 0; _i2 < triangles.length; _i2 += 3) {
        indices.push(triangles[_i2] + vertPos);
        indices.push(triangles[_i2 + 1] + vertPos);
        indices.push(triangles[_i2 + 2] + vertPos);
      }
      for (var _i3 = 0; _i3 < points.length; _i3++) {
        verts.push(points[_i3]);
      }
    }
  }
};
export { buildPoly };